import type { GameState } from "../components/Game";

const calculateNextValue = (squares: GameState) => {
  return squares.filter(Boolean).length % 2 === 0 ? "X" : "O";
};

export default calculateNextValue;
